import { ArrowUp } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LangContext";
import { SITE } from "@/data/site";
import { InstagramIcon, WhatsAppIcon } from "./Icons";
import { waLink } from "@/data/site";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="relative bg-hammer-red text-bone overflow-hidden">
      <div className="grain-layer" />
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-24 md:pb-8">
        <div className="grid md:grid-cols-3 gap-10 font-mono text-sm">
          <div>
            <p className="text-[11px] uppercase tracking-[0.25em] text-bone/70">Hammer Gym Studios</p>
            <p className="mt-3 text-bone">{t.footer.tagline}</p>
            <p className="mt-1 text-bone/80">{SITE.street}, {SITE.city}</p>
          </div>
          <div>
            <p className="text-[11px] uppercase tracking-[0.25em] text-bone/70">{t.strip.hoursLabel}</p>
            <p className="mt-3">{t.strip.hours}</p>
            <a href={SITE.tel} data-testid="footer-phone-link" className="block mt-1 link-slide w-max">{SITE.phoneIntl}</a>
          </div>
          <div className="flex md:justify-end items-start gap-3">
            <a href={SITE.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" aria-label="Instagram" className="w-12 h-12 grid place-items-center border-2 border-bone hover:bg-bone hover:text-hammer-red transition-colors">
              <InstagramIcon className="w-5 h-5" />
            </a>
            <a href={waLink(t.wa.prefill)} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" aria-label="WhatsApp" className="w-12 h-12 grid place-items-center border-2 border-bone hover:bg-bone hover:text-hammer-red transition-colors">
              <WhatsAppIcon className="w-5 h-5" />
            </a>
            <a href="#top" data-testid="footer-back-top" aria-label={t.footer.backTop} className="w-12 h-12 grid place-items-center bg-ink border-2 border-ink hover:bg-bone hover:text-ink transition-colors">
              <ArrowUp className="w-5 h-5" />
            </a>
          </div>
        </div>

        <p aria-hidden="true" className="font-display text-[min(22vw,20rem)] leading-[0.78] mt-12 -mb-2 text-ink select-none whitespace-nowrap">
          HAMMER GYM
        </p>

        <div data-testid="footer-copyright-notice" className="mt-6 border-2 border-ink bg-ink text-bone px-5 py-4 flex flex-col sm:flex-row gap-3 sm:items-start">
          <span className="shrink-0 font-mono text-[11px] uppercase tracking-[0.2em] bg-hammer-red px-2 py-1 w-max">© {t.footer.previewTitle}</span>
          <p className="text-xs sm:text-sm leading-relaxed text-bone/85">{t.footer.preview}</p>
        </div>

        <div className="mt-6 pt-5 border-t-2 border-ink/40 flex flex-col sm:flex-row gap-3 justify-between font-mono text-[11px] uppercase tracking-[0.18em] text-bone/85">
          <span data-testid="footer-rights">© {new Date().getFullYear()} {t.footer.rightsOwner}. {t.footer.rights} {t.footer.rightsFor}</span>
          <span className="font-hand normal-case tracking-normal text-base">{t.footer.made}</span>
          <Link to="/admin" data-testid="footer-admin-link" className="link-slide w-max">{t.footer.admin}</Link>
        </div>
      </div>
    </footer>
  );
};
